<template>
  <div>
    <b-card>


      <b-row class="mb-1">
        <b-col md="4">
          <b-form-input placeholder="Cari" v-model="filter.gradeName" />
        </b-col>
        <b-col class="text-right">
          <b-button
            v-b-modal.form-grade-modal
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            @click="cleanUpForm()">
            Tambah
          </b-button>
        </b-col>
      </b-row>

      <BaseTable
        :fields="fields"
        :items="items"
        :loading="loading"
        :rows="pagination.total"
        :perPage="filter.size"
        :currentPage="filter.page"
        :handle-page-change="handlePageChange"
        :detail-item="detailItem"
        :edit-item="editItem"
        :delete-item="deleteItem"
      />

      <FormGrade
        :page-title="pageTitle"
        :loading="loading"
        :edit-id="editId"
        :create-item="createItem"
        :update-item="updateItem"
        :formPayload="formPayload"
        @formPayloadParamSystem="getPayload($event)"
      />

      <DetailGrade :page-title="pageTitle" :result="detail" />
    </b-card>
  </div>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";

import { GradeService } from "@/services/grade.service";

import {
  BCard,
  BRow,
  BCol,
  BButton,
  BFormInput,
  BSpinner,
} from "bootstrap-vue";
import { successNotification, errorNotification } from "@/auth/utils";
import vSelect from "vue-select";

import BaseTable from "@/components/BaseTable.vue";
import DetailGrade from "@/components/Grade/DetailGrade.vue";
import BranchListComponent from "@/components/Base/BranchListComponent.vue";
import EmployeeListComponent from "@/components/Base/EmployeeListComponent.vue";
import FormGrade from "@/components/Grade/FormGrade.vue";

export default {
  name: "ParamSystemPage",

  components: {
    BaseTable,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BSpinner,
    vSelect,
    DetailGrade,
    BranchListComponent,
    EmployeeListComponent,
    FormGrade,
  },

  directives: {
    Ripple,
  },

  watch: {
    filter: {
      handler: _.debounce(function (value) {
        this.fetchData();
      }, 300),
      deep: true,
    },
  },

  setup() {
    return {
      successNotification,
      errorNotification,
      BaseTable,
    };
  },

  data() {
    return {
      key: "grade",
      pageTitle: "Grade",
      items: [],
      detail: Object,
      error: false,
      loading: false,
      pagination: {
        total: 0,
      },
      filter: {
        gradeName: "",
        page: 1,
        size: 10,
        gradeColumn: "CREATED_DATE",
        sortDirection: "DESC",
      },
      fields: [
        {
          key: "no",
          label: "No",
        },
        {
          key: "gradeName",
          label: "Nama Grade",
        },
        {
          key: "jobGrade",
          label: "Job Grade",
        },
        {
          key: "band",
          label: "Band",
        },
        {
          key: "actions",
          label: "Aksi",
        },
      ],
      editId: null,
      formPayload: Object,
      isLoadingEmployeeList: false,
      filterValue: null,
    };
  },

  methods: {
    cleanUpForm() {
      this.editId = null;
      this.formPayload = {
        bandId: 0,
        gradeName: "",
        jobGrade: 0
      };
    },
    filterData() {
      this.fetchData();
    },
    async fetchData() {
      this.prepareFilter();
      this.loading = true;
      try {
        const { data } = await GradeService.findAll(this.filter);

        this.items = data.content;
        this.pagination.total = data.total;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    detailItem(item) {
      this.detail = item;
      this.$bvModal.show("detail-" + this.key + "-modal");
    },
    editItem(item) {
      this.editId = item.gradeId;
      this.formPayload = {
        bandId: item.band ? item.band.bandId : item.band,
        gradeName: item.gradeName,
        jobGrade: item.jobGrade
      };
      this.showFormModal();
    },
    async createItem() {
      this.loading = true;

      try {
        await GradeService.create(this.formPayload);
        successNotification(
          this,
          "Success",
          `${this.pageTitle} berhasil dibuat!`
        );
        this.hideFormModal();
        this.fetchData();
      } catch (e) {
        this.error = e.message;
        errorNotification(this, "Oops!", e.message);
      } finally {
        this.loading = false;
      }
    },
    async updateItem() {
      this.loading = true;

      try {
        await GradeService.update(this.editId, this.formPayload);
        successNotification(
          this,
          "Success",
          `${this.pageTitle} berhasil diubah!`
        );
        this.hideFormModal();
        this.fetchData();
      } catch (e) {
        this.error = e.message;
        errorNotification(this, "Oops!", e.message);
      } finally {
        this.loading = false;
      }
    },
    deleteItem(item) {
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin menghapus data ini?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await GradeService.delete(item.gradeId);
            successNotification(
              this,
              "Success",
              `${this.pageTitle} berhasil dihapus!`
            );
            this.hideFormModal();
            this.fetchData();
          } catch (e) {
            this.error = e.message;
            errorNotification(this, "Oops!", e.message);
          } finally {
            this.loading = false;
          }
        }
      });
    },
    getPayload(value) {
      if (value) {
        this.formPayload = value;
      }
    },
    prepareFilter() {
      for (const key in this.filter) {
        if (this.filter.hasOwnProperty(key) && this.filter[key] != null) {
          if (this.filter[key] == null || this.filter[key] == "") {
            delete this.filter[key];
          }
        }
      }
      return this.filter;
    },
    preparePayload() {
      const form = new FormData();
      for (const key in this.formPayload) {
        if (
          this.formPayload.hasOwnProperty(key) &&
          this.formPayload[key] != null
        ) {
          form.append(key, this.formPayload[key]);
        }
      }

      return form;
    },
    showFormModal() {
      this.$bvModal.show(`form-${this.key}-modal`);
    },
    hideFormModal() {
      this.$bvModal.hide(`form-${this.key}-modal`);
    },
    handlePageChange(value) {
      this.loading = true;
      this.filter.page = value;
    },
  },

  created() {
    this.fetchData();
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
